import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'angular4-social-login';
import { CookieService } from 'ngx-cookie';
import { AuthenticationService } from './../../_services/index';

@Component({
  selector: 'app-leftsidebar',
  templateUrl: './leftsidebar.component.html',
  styleUrls: ['./leftsidebar.component.css'],
  providers: [AuthenticationService]
})
export class LeftsidebarComponent implements OnInit {

  currentUser: any;
  public loginFlag = false;
  public isCollapsed = true;
  public isCollapsedSm = true;
  itmeClass:string='plus';

  constructor(private router: Router,
    private authService: AuthService,
    private _cookieService: CookieService,
    private loginservice: AuthenticationService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (localStorage.getItem('currentUser') != null) {
      this.loginFlag = true;
    }
  }

  ngOnInit() {

  }

  public collapsed(event: any): void {
  }

  public expanded(event: any): void {
  }

  changeItemClass() {
    if (this.itmeClass == 'plus') {
        this.itmeClass = 'minus'
    } else {
        this.itmeClass = 'plus'
    }
  }

  signout() {

    //this.authService.signOut();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');

    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    const countLength = parts.length;
    const subdomain = parts.shift();
    if (countLength === 1) {
      this._cookieService.remove('token', {
        domain: getDomainName,
      });
    }
    if (countLength === 2) {
      this._cookieService.remove('token', {
        domain: getDomainName,
      });
    }

    if (localStorage.removeItem('currentUser') == null) {
      this.router.navigate(['/login']);
    }
    this.router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/leftsidebar/leftsidebar.component.ts